<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>Relatorios</h5>
            </b-card-header>
            <b-card-body> </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    components: {}
}
</script>
